import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth0-sdk-test',
  templateUrl: './auth0-sdk-test.component.html',
  styleUrls: ['./auth0-sdk-test.component.css'],
})
export class Auth0SdkTestComponent implements OnInit {
  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }
}
